
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 2.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM14.5 7a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM6 19a1 1 0 01-1-.984 1.618 1.618 0 01.074-.325c.081-.245.255-.606.633-.984C6.453 15.961 8.154 15 12 15s5.547.96 6.293 1.707c.378.378.552.739.633.984a1.612 1.612 0 01.074.325A1 1 0 0118 19H6zm15-1.002V18a3 3 0 01-3 3H6a3 3 0 01-3-3V17.956a1.998 1.998 0 01.026-.27 3.61 3.61 0 01.15-.627 4.528 4.528 0 011.117-1.766C5.547 14.039 7.846 13 12 13s6.453 1.04 7.707 2.293a4.529 4.529 0 011.117 1.766 3.61 3.61 0 01.172.83l.003.067v.025l.001.01v.007z","fill":"currentColor"}})])
          )
        }
      }
    